/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CredentialIssuanceExecutionRequest
 */
export interface CredentialIssuanceExecutionRequest {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof CredentialIssuanceExecutionRequest
     */
    workflowInstanceId: string;
}

/**
 * Check if a given object implements the CredentialIssuanceExecutionRequest interface.
 */
export function instanceOfCredentialIssuanceExecutionRequest(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    return true;
}

export function CredentialIssuanceExecutionRequestFromJSON(json: any): CredentialIssuanceExecutionRequest {
    return CredentialIssuanceExecutionRequestFromJSONTyped(json, false);
}

export function CredentialIssuanceExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialIssuanceExecutionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
    };
}

export function CredentialIssuanceExecutionRequestToJSON(value?: CredentialIssuanceExecutionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
    };
}

